import { render, staticRenderFns } from "./ModalYesNoGeneric.vue?vue&type=template&id=05635e6e&"
import script from "./ModalYesNoGeneric.vue?vue&type=script&lang=js&"
export * from "./ModalYesNoGeneric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports